import { useTranslation } from 'react-i18next';

import { SectionContainer, StyledRadioButton } from 'components/shared';
import { DeliveryType } from 'interfaces';
import { ButtonGroup } from 'storybook';

import styles from './SelectDeliveryTypeSection.module.css';

type SelectDeliveryTypeSectionProps = {
   selectedDeliveryType: DeliveryType;
   onDeliveryTypeChange: (value: DeliveryType) => void;
};

const SelectDeliveryTypeSection = ({
   selectedDeliveryType,
   onDeliveryTypeChange,
}: SelectDeliveryTypeSectionProps) => {
   const { t } = useTranslation();

   return (
      <SectionContainer title={t('order_summary.delivery_type.title')}>
         <ButtonGroup
            label={t('select_delivery_type.label')}
            containerClassName={styles.buttonGroupContainer}
         >
            <StyledRadioButton
               label={t('order_summary.delivery_type.ADDED_TO_NEXT_ORDER')}
               checked={selectedDeliveryType === 'ADDED_TO_NEXT_ORDER'}
               buttonView
               onChangeHandler={() => onDeliveryTypeChange('ADDED_TO_NEXT_ORDER')}
            />
            <StyledRadioButton
               label={t('order_summary.delivery_type.SEPARATE_ORDER')}
               checked={selectedDeliveryType === 'SEPARATE_ORDER'}
               buttonView
               onChangeHandler={() => onDeliveryTypeChange('SEPARATE_ORDER')}
            />
         </ButtonGroup>
      </SectionContainer>
   );
};

export default SelectDeliveryTypeSection;
